// @ts-expect-error not migrated to TS
import DowngradeActionDisabledTooltip from 'EmailComponents/modals/actionModals/DowngradeActionDisabledTooltip';
// @ts-expect-error not migrated to TS
import ActionTooltip from 'EmailComponents/modals/actionModals/ActionTooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIsConvertibleToDragAndDrop, getIsDragDropEmail } from 'EmailData/utils/emailStateUtil';
import { canCreateClassicEmail, canCreateDragDropEmail
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Emai... Remove this comment to see the full error message
} from 'EmailData/selectors/user';
import { getIsMembershipEmail } from 'EmailData/utils/emailStateUtil';
import { jsx as _jsx } from "react/jsx-runtime";
export const ACTION_MODAL_TYPES = {
  ARCHIVE: 'archive',
  ASSIGN_TEAMS: 'assignTeams',
  MOVE_TO_FOLDER: 'moveToFolder',
  CLONE: 'clone',
  DELETE: 'delete',
  VIEW_DETAILS: 'viewDetails',
  EDIT: 'edit',
  COMMENT: 'comment',
  SAVE_AS_TEMPLATE: 'saveAsTemplate',
  LOCKED_SAVE_AS_TEMPLATE: 'lockedSaveAsTemplate',
  LOCKED_ADD_TO_SIMPLE_WORKFLOW: 'lockedAddToSimpleWorkflow',
  UNPUBLISH: 'unpublish',
  UNARCHIVE: 'unarchive',
  VIEW_EMAIL: 'viewEmail',
  VIEW_PERFORMANCE: 'viewPerformance',
  VIEW_INSIGHTS: 'viewInsights',
  GENERATE_TRANSLATED_VERSION: 'generateTranslatedVersion'
};
export const DETAIL_ACTIONS = {
  CANCEL_PROCESSING: 'CANCEL_PROCESSING',
  CANCEL_WINNING_SEND: 'CANCEL_WINNING_SEND',
  EDIT_SCHEDULED: 'EDIT_SCHEDULED',
  EDIT_AB_AUTOMATED: 'EDIT_AB_AUTOMATED',
  EDIT_EMAIL_AUTOMATION: 'EDIT_EMAIL_AUTOMATION',
  CANCEL_SCHEDULED: 'CANCEL_SCHEDULED',
  EDIT: 'EDIT',
  CLONE_PRIMARY_EMAIL: 'CLONE_PRIMARY_EMAIL',
  CLONE_AB_MASTER: 'CLONE_AB_MASTER',
  CLONE_AB_VARIANT: 'CLONE_AB_VARIANT',
  CANCEL: 'CANCEL',
  UNARCHIVE: 'UNARCHIVE',
  ARCHIVE: 'ARCHIVE',
  DELETE: 'DELETE',
  DOCUMENTATION_LINK: 'DOCUMENTATION_LINK',
  EXPORT_PERFORMANCE: 'EXPORT_PERFORMANCE',
  EXPORT_RECIPIENTS: 'EXPORT_RECIPIENTS',
  TEST_SEND: 'TEST_SEND',
  UNBOUNCE_RECIPIENT: 'UNBOUNCE_RECIPIENT',
  SEND_TO_MORE: 'SEND_TO_MORE',
  CREATE_LIST: 'CREATE_LIST',
  APPEND_LIST: 'APPEND_LIST',
  UNPUBLISH_RSS: 'UNPUBLISH_RSS',
  UNPUBLISH_BLOG: 'UNPUBLISH_BLOG',
  UNPUBLISH: 'UNPUBLISH',
  MANAGE_TEST: 'MANAGE_TEST',
  EDIT_CAMPAIGN: 'EDIT_CAMPAIGN',
  MOVE_TO_FOLDER: 'MOVE_TO_FOLDER',
  ADD_AUTOMATION: 'ADD_AUTOMATION',
  ADD_CONTEXTUAL_AUTOMATION: 'ADD_CONTEXTUAL_AUTOMATION',
  ADD_TO_SIMPLE_WORKFLOW: 'ADD_TO_SIMPLE_WORKFLOW',
  LOCKED_ADD_TO_SIMPLE_WORKFLOW: 'LOCKED_ADD_TO_SIMPLE_WORKFLOW',
  VIEW_REVISIONS: 'VIEW_REVISIONS',
  MANAGE_LEADFLOW: 'MANAGE_LEADFLOW',
  SMTP_RESET_PASSWORD: 'SMTP_RESET_PASSWORD',
  SMTP_DELETE_TOKEN: 'SMTP_DELETE_TOKEN',
  EDIT_WEB_VERSION: 'EDIT_WEB_VERSION',
  COMMENT: 'COMMENT',
  SAVE_AS_TEMPLATE: 'SAVE_AS_TEMPLATE',
  LOCKED_SAVE_AS_TEMPLATE: 'LOCKED_SAVE_AS_TEMPLATE',
  SEND_TO_SLACK: 'SEND_TO_SLACK',
  COMPARE_EMAIL: 'COMPARE_EMAIL',
  LOCKED_COMPARE_EMAIL: 'LOCKED_COMPARE_EMAIL',
  GENERATE_TRANSLATED_VERSION: 'GENERATE_TRANSLATED_VERSION'
};
export const EMAIL_ACTION_TYPES = {
  CLONE_OR_CONVERT: 'cloneOrConvert',
  EDIT_OR_CONVERT: 'editOrConvert'
};
export const actionDisabledForClassicTemplate = action => (email, gates, scopes) => {
  if (getIsDragDropEmail(email)) {
    return false;
  }
  if (canCreateClassicEmail(scopes)) {
    return false;
  }
  if ((action === 'clone' || action === 'editOrConvert') && canCreateDragDropEmail(Object.keys(gates), scopes) && getIsConvertibleToDragAndDrop(email)) {
    return false;
  }
  return {
    disabled: true,
    tooltip: /*#__PURE__*/_jsx(DowngradeActionDisabledTooltip, {
      action: action
    })
  };
};
export const editRestrictedForClassicTemplate = actionDisabledForClassicTemplate('edit');
export const saveTemplateDisabled = (email, gates, scopes) => {
  if (!scopes.includes('design-manager-access')) {
    return {
      disabled: true,
      tooltip: /*#__PURE__*/_jsx(ActionTooltip, {
        message: "EmailComponents.saveAsTemplate.permissionDisabled"
      })
    };
  }
  if (email.isBlogEmail() || email.isBlogChildEmail() || email.isRssEmail() || email.isRssChildEmail()) {
    return {
      disabled: true,
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "EmailComponents.saveAsTemplate.blogRssDisabled"
      })
    };
  }
  if (email.isOptinEmail()) {
    return {
      disabled: true,
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "EmailComponents.saveAsTemplate.optInDisabled"
      })
    };
  }
  if (getIsMembershipEmail(email)) {
    return {
      disabled: true,
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "EmailComponents.saveAsTemplate.registrationEmail"
      })
    };
  }
  return false;
};